/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates.
 * Licensed under The Universal Permissive License (UPL), Version 1.0
 * as shown at https://oss.oracle.com/licenses/upl/
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox'>;
const SvgZoomAlt = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M15.95 6.05a7 7 0 1 0-9.9 9.9 7 7 0 0 0 9.9-9.9zM4.636 4.636a9 9 0 0 1 13.396 11.982l3.675 3.675-1.414 1.414-3.675-3.675A9.001 9.001 0 0 1 4.636 4.636z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgZoomAlt as ZoomAlt };
